export default __webpack_public_path__ + "b9e68db1cd55a62afa0263d94ae189d0.svg";